export enum TemplateType {
	Header = 1,
    Letter = 2,
    Email = 3,
    Other = 99,
}
